import { useHistory } from "react-router";
import { Button } from "../../components/button/button";

const COMPONENT_CLASS = "c-msk-lite-tool";

const MskLiteTool: React.FC = () => {
    const history = useHistory();

    const startDemo = () => {
        history.push("/msk-lite");
    };

    return (
        <div className={COMPONENT_CLASS}>
            <h2>MSK Lite Assessment Demo</h2>
            <p>This tool allows you to test the MSK Lite API endpoint.</p>
            <p>The MSK Lite assessment:</p>
            <ul>
                <li>Uses 4 groups: Movement, Body Composition, Physical Activity, Injury History</li>
                <li>Runs independently from the regular wellness assessment</li>
                <li>Does NOT create wellness programs, correctives, or articles</li>
            </ul>
            <p>Click the button below to start the MSK Lite assessment flow.</p>
            <Button onClick={startDemo} buttonText="Start Msk Lite Demo" />
        </div>
    );
};

export default MskLiteTool;